import { render, staticRenderFns } from "./ListaGadget.vue?vue&type=template&id=3cd23bc7&"
import script from "./ListaGadget.vue?vue&type=script&lang=js&"
export * from "./ListaGadget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports